import { useMutation, useQuery } from "@apollo/client";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { emtSocket } from "../../../../../CommonFunction/SocketClient";
import { replaceUnderscore } from "../../../../../CommonFunction/common";
import {
  EDIT_COMMITTED_VEHICLES_DATA_WITHOUT_VERIFY_BALANCE,
  GET_VEHICLES_DATA,
} from "../../../../../Utils/AllPagesQuriesAndMutations";
import AddVehicleAtBid from "../../../../Pages/LoadEntry/AddVehicleAtBid";
import Button from "../../../Button/Button";
import { FormInputSectionComponent } from "../../../FormInputSectionComponent/FormInputSectionComponent";
import PortalFooter from "../../../Reactportal/PortalFooter";
// import Reactportal from "../../../SpComponents/Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../../ToastComponent/RectHotToast";
import CnfModal from "../CnfModalSP/CnfModal";
import { Award_Accepted_Fields } from "./AwardedAcceptedInputConfig";
import "./AwardedAcceptedModal.scss";
import Reactportal from "../../../Reactportal/Reactportal";

function AwardedAcceptedModal({
  ID,
  SpId,
  onClose,
  RefetchUpdated,
  Vehicle_No,
  loadId,
}) {
  const [isEditCommittedVehicles, setIsEditCommittedVehicles] = useState(false);
  const [Vehicle_Num, setVehicleNum] = useState();
  const FormData = useSelector((store) => store.FormFieldData);
  const dispatch = useDispatch();
  const [showAddVehicleModal, setShowAddVehicleModal] = useState(false);
  const [editCommittedVehicles, { loading: editCommittedVehiclesLoading }] =
    useMutation(EDIT_COMMITTED_VEHICLES_DATA_WITHOUT_VERIFY_BALANCE, {
      context: {
        headers: { "X-GraphQL-Server": "secondary" },
      },
    });

  const { data: getVehiclesDataD } = useQuery(GET_VEHICLES_DATA, {
    variables: {
      UserId: SpId,
    },
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    fetchPolicy: "network-only",
  });
  const [vehiclesDropDown, setVehiclesDropDown] = useState([]);
  useEffect(() => {
    dispatch({
      type: "SearchMasterData",
      payload: { SpId: { _id: SpId } },
    });
    dispatch({
      type: "SearchMasterData",
      payload: { Vehicle_Number: { _id: Vehicle_No?._id } },
    });
    setVehicleNum({ Vehicle_Number: Vehicle_No?.Vehicle_No });
  }, [SpId, Vehicle_No]);
  useEffect(() => {
    if (
      getVehiclesDataD &&
      getVehiclesDataD.GetVehicleManagementDetailsByUserId
    ) {
      setVehiclesDropDown(getVehiclesDataD.GetVehicleManagementDetailsByUserId);
    }
  }, [getVehiclesDataD]);

  let vehicleNumbersData;

  vehicleNumbersData = vehiclesDropDown?.map(({ Vehicle_No, _id }) => ({
    value: Vehicle_No,
    label: Vehicle_No,
    id: _id,
  }));

  const [cnfModalTwo, setCnfModalTwo] = useState(false);

  const initialValues = {
    Vehicle_Number: "",
    Driver_Name: "",
    Driver_Number: "",
    Reporting_Time: "",
  };

  const validate = (values) => {
    let errors = {};

    if (!values.Driver_Name) {
      errors.Driver_Name = "Driver name required";
    } else if (!values.Driver_Number) {
      errors.Driver_Number = "Driver number required";
    } else if (!/^\d{10}$/.test(values.Driver_Number)) {
      errors.Driver_Number = "Driver number must be 10 digits";
    } else if (!values.Reporting_Time) {
      errors.Reporting_Time = "Reporting time required";
    }

    return errors;
  };

  const onSubmit = async (values) => {
    await updateCommittedVehicles(ID);
  };

  const formik = useFormik({
    initialValues,
    validate,
    onSubmit,
  });

  const handleformikdata = (Value, id) => {
    let data = Value;
    if (isNaN(+data) === true) {
      data = Value;
    } else {
      data = +Value;
    }
    formik.setFieldValue(id, data);
  };
  async function updateCommittedVehicles(id) {
    delete FormData.fielddata.Award_Accepted.Vehicle_Number;

    await editCommittedVehicles({
      variables: {
        editCommittedVehiclesWithoutVerifyUserWithBalanceId: id,
        userInput: {
          ...FormData.fielddata.Award_Accepted,
          Vehicle_Number: FormData.masterData.Vehicle_Number._id,
          Is_Accepted: true,
          Is_Rejected: false,
          Current_Stage: "Booking Confirmed",
          TripBooking_Confirmed: true,
          TripBooking_Confirmed_Time: new Date(),
        },
      },
    })
      .then(() => {
        onClose();
        SuccessToast("Awarded Vehicle Accepted Successfully");
        // emtSocket.emit("EditConfirmVechileswithId", loadId);
        RefetchUpdated();
        dispatch({ type: "Refetch", payload: true });
      })
      .catch((err) => ErrorToast(err.message));
  }

  const handleValidation = () => {
    if (FormData?.masterData?.Vehicle_Number?._id) {
      setCnfModalTwo(true);
    } else {
      ErrorToast("Please Select Vehicle Number");
    }
  };

  useEffect(() => {
    if (editCommittedVehiclesLoading)
      setIsEditCommittedVehicles(editCommittedVehiclesLoading);
  }, [editCommittedVehiclesLoading]);

  return (
    <div className="awardedAcceptedModal">
      <div className="formContainer">
        {Award_Accepted_Fields.map((e, i) => {
          return (
            <div className="FormSectionParent">
              <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
              <div className="FormSection insidecontainer">
                <FormInputSectionComponent
                  handelformikdata=""
                  inputfields={e.fields}
                  Type={e.name}
                  fielddata={Vehicle_Num}
                />
              </div>
            </div>
          );
        })}
        {showAddVehicleModal && (
          <AddVehicleAtBid
            show={showAddVehicleModal}
            id={""}
            TypeOfPortal={"Add"}
            submitType={""}
            ParentPortalCloseFunction={() => setShowAddVehicleModal(false)}
          />
        )}
      </div>

      <div className="addvehiclebutton">
        <Button
          name="modalbutton"
          text={"Add Vehicle"}
          action={() => setShowAddVehicleModal(true)}
        ></Button>
      </div>

      <PortalFooter>
        <Button
          text="Confirm"
          name="modalbutton"
          type="button"
          className={"acceptBtn"}
          action={handleValidation}
        />

        <Reactportal
          open={cnfModalTwo}
          modalHeading="Bid Confirmation"
          onClose={() => setCnfModalTwo(false)}
          modalClassName={"cnfModal"}
          contentClassName={"cnfModal-content"}
        >
          <CnfModal
            newBidDetails={() => onSubmit()}
            listArr={[
              "The vehicle number commited cannot be changed here after.",
              "If vehicle not placed an amount of Rs. 500/- will be deducted and your rating will be downgraded.",
            ]}
            onClose={() => setCnfModalTwo(false)}
            loading={isEditCommittedVehicles}
          />
        </Reactportal>

        <Button
          text="Back"
          name="modalbutton"
          className={"rejectBtn"}
          action={onClose}
        />
      </PortalFooter>
      {/* </form > */}
    </div>
  );
}

export default AwardedAcceptedModal;
